const Depth = 6;

export const mapConfig = {
  // 地图挤出厚度
  mapDepth: Depth,
  // 地图透明度
  mapTransparent: true,
  mapOpacity: 0.72,
  // 地图颜色
  mapColor: "#06092A", // 地图原本颜色
  mapHoverColor: "#409EF9", // 地图hover颜色
  // 随机顶面色（色差收窄，仍保留轻微层次）
  mapColorGradient: ["#1B6FE8", "#1763D4", "#1458C0", "#124FAD"],
  // 地图侧面渐变
  mapSideColor1: "#3F9FF3",
  mapSideColor2: "#266BF0",
  // 上面的line
  topLineColor: 0x41c0fb,
  topLineWidth: 1,
  topLineZIndex: Depth + 0.5,
  // label 2d高度
  label2dZIndex: Depth + 2,
  // 飞线多段渐变（沿轨迹 0% → 100%）
  flyLineGradientStops: [
    { offset: 0, color: "rgb(225, 79, 173)" },
    { offset: 1, color: "rgb(249, 212, 35)" },
  ],
  // 飞线箭头视觉尺寸（世界空间恒定，创建时按 mapScale 反向补偿）
  flyArrowWorldSize: 2.4,
  // 飞线箭头匀速速度（屏幕视觉近似恒定，会按 mapScale 补偿）
  flyArrowSpeed: 8,
  // spot（默认值会在构建地图时按行政级别覆盖）
  spotZIndex: Depth + 0.2,
  spotRadius: 0.2,
  spotRingWidth: 0.1,
  // 各级默认扩散点尺寸（越下钻越小，避免乡镇层铺满区域）
  spotRadiusByLevel: {
    province: 0.28,
    city: 0.16,
    district: 0.08,
    street: 0.035,
    town: 0.02,
  } as Record<string, number>,
  spotRingWidthByLevel: {
    province: 0.12,
    city: 0.07,
    district: 0.035,
    street: 0.015,
    town: 0.01,
  } as Record<string, number>,
};

export function updateMapDepth(depth: number) {
  mapConfig.mapDepth = depth;
  mapConfig.topLineZIndex = depth + 0.5;
  mapConfig.label2dZIndex = depth + 2;
  mapConfig.spotZIndex = depth + 0.2;
}

/** 按当前地图要素级别设置扩散点半径 */
export function applySpotSizeForLevel(level?: string | null) {
  const key =
    level && mapConfig.spotRadiusByLevel[level] != null ? level : "province";
  mapConfig.spotRadius = mapConfig.spotRadiusByLevel[key];
  mapConfig.spotRingWidth = mapConfig.spotRingWidthByLevel[key];
}
